import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const OutstandingRulesInitPage = lazyImport(() => import('~/views/outstanding-rules/OutstandingRulesInitPage'));
const OutstandingRulesWelcomePage = lazyImport(() => import('~/views/outstanding-rules/OutstandingRulesWelcomePage'));
const NewOutstandingRulePage = lazyImport(() => import('~/views/outstanding-rules/NewOutstandingRulePage'));
const EditOutstandingRulePage = lazyImport(() => import('~/views/outstanding-rules/EditOutstandingRulePage'));
const OutstandingRulesListPage = lazyImport(() => import('~/views/outstanding-rules/OutstandingRulesListPage'));

export const outstandingRulesRoutes: RouteObject[] = [
  {
    index: true,
    element: <OutstandingRulesInitPage />,
  },
  {
    path: ':direction/welcome',
    element: <OutstandingRulesWelcomePage />,
  },
  {
    path: ':direction/new',
    element: <NewOutstandingRulePage />,
  },
  {
    path: 'edit/:ruleId',
    element: <EditOutstandingRulePage />,
  },
  {
    path: ':direction/list',
    element: <OutstandingRulesListPage />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Outstanding.buildLink()} replace />,
  },
];
